(ns teamoesterreich.admin-mode.detail-filter.canYou-filter
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.event :as d-events]
            [teamoesterreich.admin-mode.static-data :as staticData]
            [teamoesterreich.util.helper :as h]             ;
            [teamoesterreich.util.log :as log]))




(defn wait-do [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (reset! !loaded? false))
                500)))))


(defn wait-do-select [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" val)
      (event-fn val)
      (reset! !waiting? false)
      (reset! !loaded? false))))


(defn wait-do-check [!waiting? !loaded? event-fn]
  (fn [e val]
    (js/console.log "wait or do" val)
    (event-fn val)
    (reset! !waiting? false)
    (reset! !loaded? false)))


(defn check-box [!waiting? !loaded? !detail-search name add-filter-key]

  [mui/form-control-label {:label   name :value "dst" :placement "start"
                           :control (r/as-element [mui/checkbox {:checked  (= name (get-in @!detail-search [add-filter-key]))
                                                                 :onChange (wait-do-check !waiting? !loaded? (fn [val] (swap! !detail-search assoc add-filter-key (if val name ""))))
                                                                 }])}]

  )


(def !st (r/atom {:loaded false :data []}))
(def !loaded (r/cursor !st [:loading]))
(def !data (r/cursor !st [:data]))
(defn canYou-block [!detail-search !waiting? !loaded?]
  (let []

    (log/debug "CanYou select data:  " (clj->js @!detail-search))
    (when-not @!loaded
      (d-events/get-canYou-event-list-elements
        (fn [data]
          (reset! !data (filter (fn [[k e]]
                                  (or (= "collecting" (:_crowdtaskerEvent-status e))
                                      (= "finished" (:_crowdtaskerEvent-status e)))
                                  ) data))
          (reset! !loaded true)
          )))
    [mui/grid
     {:item  true
      :xs    12
      :style {:marginBottom "7px"}
      }



     [mui/paper
      [mui/grid
       {:container  true
        :direction  "row"
        :alignItems "flex-start"
        :justify    "flex-start"
        :spacing    1
        :style      {:padding "5px"}
        }

       [mui/grid
        {:item true
         :lg   2
         :md   3
         :xs   6
         }
        [mui/typography "Kannst Du "]
        ]


       [mui/grid
        {:item true
         :lg   3
         :md   6
         :sm   8
         :xs   12
         }

        [mui/form-control
         {
          :fullWidth true
          }
         [mui/input-label "Einsatz wählen"]
         [mui/select
          {:multiple false
           :value    (or (get-in @!detail-search [:filter-canYou]) [])
           :onChange (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-canYou val)))

           }

          (for [[key val] @!data]
            [mui/menu-item {:key (str "deg_" key) :value key} (:crowdtaskerEvent-name val)])

          ]]]


       [mui/grid
        {:item true
         :lg   2
         :md   3
         :xs   3
         }
        [mui/typography "Antwort"]
        ]
       [mui/grid
        {:item true
         :md   3
         :xs   3
         }

        [mui/form-control
         {
          :component "fieldset"
          :fullWidth true
          }
         [mui/radio-group {:row true :class "filterRadio"}


          [check-box !waiting? !loaded? !detail-search "Ja" :filter-canYouAnswer]
          [check-box !waiting? !loaded? !detail-search "Nein" :filter-canYouAnswer]

          ]

         ]

        ]]]]))